import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import history from 'src/history'
import classNames from 'classnames'
import { defineMessages } from 'react-intl'
import { useFormatMessage } from 'src/providers/intl'

// Assets
import { ExitFullScreenSvg } from 'src/svgs'

// Components
import { Button } from 'src/Components'

// Selectors
import { selectCustomerId } from 'src/store/selectors/customerProfile'

// Constants
import { PATH_HELPERS } from 'src/constants/navigation'

// Styles
import styles from './ExitFullScreenButton.module.scss'

interface ExitFullScreenButtonProps {
  listingId: string
  className?: string
}

const ExitFullScreenButton = ({
  listingId,
  className,
}: ExitFullScreenButtonProps) => {
  const intlFormat = useFormatMessage()
  const customerId = useSelector(selectCustomerId)

  const handleOnClick = () => {
    history.push(PATH_HELPERS.listing.buildPath(customerId, listingId))
  }

  const messages = defineMessages({
    ariaLabel: {
      id: 'ExitFullScreenButton.ariaLabel',
      defaultMessage: 'Goes back to the listing detail',
    },
  })

  return (
    <Button
      aria-label={intlFormat(messages.ariaLabel)}
      data-qa='exitFullScreenButton'
      onClick={handleOnClick}
      className={classNames(styles.button, className)}
    >
      <ExitFullScreenSvg />
    </Button>
  )
}

ExitFullScreenButton.propTypes = {
  listing: PropTypes.object,
}

export default ExitFullScreenButton
